import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { ShipmentActionsUnion, ShipmentActionsTypes } from '@core/actions/shipment.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Country } from '@app/models';


export interface Shipments {
    id: number;
    FollowId: number;
    CountryId: number;
    position: number,
    semester: Text,
    createdAt: Date;
    updatedAt: Date;
    Country: Country;
}
  
export interface State extends EntityState<Shipments> {
  loading: boolean;
  loaded: boolean;
  busy: boolean;
  allShipments: any;
}

export const adapter: EntityAdapter<Shipments> = createEntityAdapter<Shipments>({
  selectId: (ship: Shipments) => ship.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  busy: false,
  allShipments: null
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ShipmentActionsUnion
) {
  switch (action.type) {
    case ShipmentActionsTypes.Load:
        return {
          ...state,
          loading: true
        };

    case ShipmentActionsTypes.LoadSuccess:
        return adapter.addAll(action.shipments, {
            ...state,
            loading: false,
            loaded: true,
            isBusy: false,
            allShipments: action.shipments
        });

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const getState = createFeatureSelector<State>('shipments');
export const getAll = createSelector(
    getState,
    selectAll
);

export const getBusy = createSelector(
  getState,
  (state: State) => state.busy
);

export const getAllShipments = createSelector(
    getState,
    getAll
);
